<template>
  <div class="col-sm-12 nopads">
    <div class="col-sm-12 editor-form" @click.stop="">
      <h2 class="editor-header">{{ observationTypeUpdate.id > 0 ? $t('observations.edit_type') : $t('observations.add_type') }} </h2>
      <div class="col-sm-12 form-data">
        <span class="span-title">{{ $t('observations.group') }}</span>
          <select
              id="group"
              v-model="group"
              class="form-select form-select-sm"
          >
              <option
                  :value="null"
                  disabled
              >
                  {{ $t('observations.select_group') }}
              </option>
              <option
                  v-for="item in groups"
                  :key="item.id"
                  :value="item.id"
              >
                  {{ item.name }}
              </option>
          </select>
          <span class="span-title">{{ $t('observations.name') }}</span>
          <input
              id="name"
              v-model="observationTypeUpdate.name"
              type="text"
              class="form-control form-control-sm"
          />

          <span class="span-title">{{ $t('observations.type') }}</span>
          <select
              id="type"
              v-model="type"
              :disabled="observationTypeUpdate.id > 0"
              class="form-select form-select-sm mb-2"
          >
              <option :value="1">
                  {{ $t('observations.point') }}
              </option>
              <option :value="2">
                  {{ $t('observations.line') }}
              </option>
          </select>

          <span class="span-title">{{ $t('observations.alert_limit') }}</span>
          <input
              id="name"
              v-model="observationTypeUpdate.alert_limit"
              type="number"
              step="any"
              class="form-control form-control-sm"
          />

        <div class="row">
          <div class="col-sm-6">
            <span class="span-title">{{ $t('observations.mandatory_info') }}</span>
              <div class="form-check form-check-sm">
                  <input
                      id="mandatory_info"
                      v-model="observationTypeUpdate.mandatory_info"
                      type="checkbox"
                      class="form-check-input"
                  />
              </div>
          </div>
          <div class="col-sm-6 nopads">
            <span class="span-title">{{ $t('inspection_editor.inactive') }}</span>
              <div class="form-check form-check-sm">
                  <input
                      id="in_active"
                      v-model="observationTypeUpdate.inactive"
                      type="checkbox"
                      class="form-check-input"
                  />
              </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 nopads">
            <span class="span-title">{{ $t('observations.numeric_info') }}</span>
              <div class="form-check form-check-sm">
                  <input
                      id="numeric_info"
                      v-model="observationTypeUpdate.numeric_info"
                      type="checkbox"
                      class="form-check-input"
                  />
              </div>
              <span class="tip-light">{{ $t('observations.numeric_info_tip') }}</span>
          </div>
          <div class="col-sm-6 nopads">
            <span class="span-title">{{ $t('observations.numeric_unit') }}</span>
              <input
                  v-model="observationTypeUpdate.numeric_unit"
                  type="text"
                  class="form-control form-control-sm"
                  :disabled="!observationTypeUpdate.numeric_info"
              />
          </div>
        </div>
        <div class="col-sm-12 d-flex justify-content-end">
          <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
            {{ $t('common.cancel') }}
          </button>
          <button class="btn btn-success form-button" :disabled="loading || !observationTypeUpdate.name || !group" @click.stop="submit">
            {{ $t('common.save') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {geomTypes, observationHelper} from '../../mixins/ObservationMixin'
import {restApi} from '../../mixins/RestApiMixin'
import {inject} from "vue";

export default {
    name: 'ObservationTypeEditor',
    mixins: [geomTypes, observationHelper, restApi],
    props: {
        observationType: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            group: null,
            groups: [],
            type: 1,
            observationTypeUpdate: this.jsonToItem(this.observationType)
        }
    },

    mounted: function () {
        this.fetchGroups()
        if (this.observationTypeUpdate.id > 0) {
            this.type = this.observationTypeUpdate.geometry_type
        }
    },

    methods: {
        fetchGroups: function () {
            this.loading = true
            this.restFetch(this.observationGroupUrl, this.handleGroupResponse)
        },

        handleGroupResponse: function (response) {
            this.groups = response.data
            this.loading = false
            if (this.observationTypeUpdate.observation_group) {
                this.group = this.observationTypeUpdate.observation_group.id
            }
        },

        setDefaultValues: function (obsType) {
            if (!obsType.name.trim() === '') {
                this.showAlert(this.$t('inspectable_editor.invalid_name'))
                return undefined
            }
            if (!this.group || this.group < 0) {
                this.showAlert(this.$t('observations.invalid_group'))
                return undefined
            }
            if (this.type !== 1 && this.type !== 2) {
                this.showAlert(this.$t('observations.invalid_type') + ' ' + this.type)
                return undefined
            }
            obsType.observation_group = {id: this.group}
            obsType.geometry_type = this.type
            return obsType
        },

        submit: function () {
            let json = this.setDefaultValues(this.observationTypeUpdate)
            if (json !== undefined) {
                this.loading = true
                if (this.observationTypeUpdate.id < 1) {
                    this.restAdd(this.observationTypeUrl, json, this.success, this.fail)
                } else {
                    this.restUpdate(this.observationTypeUrl, json, this.success, this.fail)
                }
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }

    }
}
</script>
